module.exports = __webpack_public_path__ + "img/40_26.668bc41a.png";